import { FC } from 'react';

import { useAppSelector } from '../../../store/hooks';
import { Service } from '../../../utils/_declarations/globals';
import Accordion from '../../atoms/Accordion';
import Tooltip from '../../atoms/Tooltip';

export type ServiceListItemProps = {
  service: Service;
};
const ServiceListItem: FC<ServiceListItemProps> = ({ service }) => {
  const { widgetType } = useAppSelector((state) => state.app);
  const serviceName = service.name.toUpperCase();
  return widgetType === 'modal' ? (
    <Tooltip description={service.description} label={serviceName} />
  ) : (
    <Accordion description={service.description} label={serviceName} />
  );
};

export default ServiceListItem;
